import { apiFetch, resolveEndpoint } from "./client";

async function resolvePath(preferred, fallback) {
  const found = await resolveEndpoint(preferred);
  return found || fallback;
}

export async function getDevUsers() {
  const path = await resolvePath(["/auth/dev/users"], "/auth/dev/users");
  const { data } = await apiFetch(path, { method: "GET" });
  return data || { count: 0, users: [] };
}

export async function updateDevUserPermissions(userId, payload) {
  const id = String(userId || "").trim();
  if (!id) throw new Error("userId is required");
  const path = await resolvePath(["/auth/dev/users/{target_user_id}", "/auth/dev/users/{user_id}"], `/auth/dev/users/${encodeURIComponent(id)}`);
  const resolved = path.includes("{") ? `/auth/dev/users/${encodeURIComponent(id)}` : path;
  const { data } = await apiFetch(resolved, { method: "PATCH", body: payload });
  return data || { user: null };
}